import api from "./auth"
// Invoice APIs
export const getDashboard = () => api.get("/api/invoices/dashboard");
export const getInvoices = (params) => api.get("/api/invoices", { params });
export const getInvoice = (id) => api.get(`/api/invoices/${id}`);
export const createInvoice = (data) => api.post("/api/invoices", data);
export const aiGenerateInvoice = (prompt) => api.post("/api/invoices/ai-generate", { prompt });
export const updateInvoice = (id, data) => api.put(`/api/invoices/${id}`, data);
export const deleteInvoice = (id) => api.delete(`/api/invoices/${id}`);
export const downloadPDF = (id) =>
  api.get(`/api/invoices/${id}/pdf`, { responseType: "blob" });

// Subscription
export const getPlans = () => api.get("/api/invoices/plans/list");
//export const createSubscription = (plan) => api.post("/api/invoices/subscribe/create", { plan });
export const createSubscription = (payload) => api.post("/api/invoices/subscribe/create",payload);
export const verifyPayment = (data) => api.post("/api/invoices/subscribe/verify", data);

/* =========================
   🔥 NEW (SAAS CRITICAL)
========================= */

// Get current user billing status
export const getBillingStatus = () =>
  api.get("/api/billing/status");

// Get usage (invoices used vs limit)
export const getUsage = () =>
  api.get("/api/billing/usage");

// Check if user can create invoice
export const checkInvoiceLimit = () =>
  api.get("/api/billing/check-limit");

// Update currency preference (INR/USD)
export const updateCurrency = (currency) =>
  api.post("/api/user/currency", { currency });

export default api;
